import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { PAGE_TITLE_ID } from "../app/pageTitle";

// The catch-all. Its heading is the shell's, like every other routed page (the `*` route names itself
// `notFound.heading` in router.tsx) — so what is left here is the way out, in a named region rather
// than a bare fragment.
export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <section className="not-found" aria-labelledby={PAGE_TITLE_ID}>
      <Link to="/">{t("notFound.backHome")}</Link>
    </section>
  );
}
